import { IndustryCard } from "../ui/IndustryCard";

function Mark({ children }) {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
      {children}
    </svg>
  );
}

const industries = [
  ["Data centres", (
    <Mark>
      <rect x="3" y="4" width="7" height="16" rx="1.2" fill="currentColor" opacity="0.35" />
      <rect x="14" y="4" width="7" height="16" rx="1.2" fill="currentColor" />
      <path d="M5 8h3M5 11h3M5 14h3M16 8h3M16 11h3M16 14h3" stroke="#0B1C33" strokeWidth="1.2" />
    </Mark>
  )],
  ["Corporate offices", (
    <Mark>
      <path d="M4 20V8l8-4 8 4v12H4Z" fill="currentColor" />
      <path d="M9 20v-5h6v5M10 10h1.5M12.5 10H14M10 13h1.5M12.5 13H14" stroke="#0B1C33" strokeWidth="1.2" />
    </Mark>
  )],
  ["Telecom sites", (
    <Mark>
      <path d="M12 21V8" stroke="currentColor" strokeWidth="2" />
      <path d="M8 11a5 5 0 0 1 8 0M5.5 8.5a9 9 0 0 1 13 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="12" cy="20" r="1.6" fill="currentColor" />
    </Mark>
  )],
  ["Banks", (
    <Mark>
      <path d="M3 10h18L12 4 3 10Z" fill="currentColor" />
      <path d="M6 10v7M10 10v7M14 10v7M18 10v7M4 19h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </Mark>
  )],
  ["Government", (
    <Mark>
      <path d="M12 3 4 8h16L12 3Z" fill="currentColor" />
      <path d="M6 8v8M10 8v8M14 8v8M18 8v8M4 18h16M8 21h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </Mark>
  )],
  ["Industrial facilities", (
    <Mark>
      <path d="M3 20V10l5 3V9l5 3V8h8v12H3Z" fill="currentColor" />
      <path d="M16 8V4h3v4" stroke="currentColor" strokeWidth="1.6" />
    </Mark>
  )],
];

export function IndustriesSection() {
  return (
    <section id="industries" className="relative scroll-mt-20 overflow-hidden bg-[#0B1C33] px-5 py-20 text-white">
      <div className="pointer-events-none absolute -left-16 top-10 h-56 w-56 rounded-full bg-brand-blue/40 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute bottom-0 right-10 h-64 w-64 rounded-full bg-brand-orange/30 blur-3xl" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
        <div className="rounded-xl border border-white/20 bg-white/10 p-8 shadow-[inset_0_1px_0_rgba(255,255,255,0.28)] backdrop-blur-xl">
          <p className="text-sm font-bold tracking-[0.16em] text-brand-blue">DATA CENTRE READY</p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">Designed for high-security environments</h2>
          <p className="mt-4 max-w-lg text-slate-200">GLOBOVMS is for visitor and contractor workflows where security, traceability, and controlled access matter. Each organization sees only its own visits.</p>
          <a href="#demo" className="mt-8 inline-flex items-center justify-center rounded bg-white px-5 py-3 text-base font-semibold text-brand-ink hover:bg-slate-100">Request a demo</a>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {industries.map(([label, icon], index) => <IndustryCard key={label} label={label} icon={icon} orange={index % 2 === 1} />)}
        </div>
      </div>
    </section>
  );
}
